import React, { createContext } from 'react';
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const RouterLinkProviderContext = /*#__PURE__*/createContext({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */
const RouterLinkProvider = ({
  routerLinkComponent,
  children
}) => {
  return /*#__PURE__*/React.createElement(RouterLinkProviderContext.Provider, {
    value: {
      routerLinkComponent
    }
  }, children);
};
export default RouterLinkProvider;